import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import convert from '../../helpers/convert'
import { chain, orderBy } from 'lodash'
// import {
//   Link,
//   LinkIcon
// } from '../'
// import config from '../../config'
import Styles from './CompanyList.css'
import format from '../../helpers/format'
import {Row, Col} from 'react-flexbox-grid'
import ReactTooltip from 'react-tooltip'

const MaxPerPage = 10

function mapFundHoldings(fHoldings){
  const fHoldingsMap = {}
  fHoldings.forEach((fholding)=>{
    fHoldingsMap[fholding.db_holding_id] = fholding
  })
  return fHoldingsMap
}
// function filterHoldings(fHoldingsMap, holdings, filterFn){
//   return chain(holdings)
//   .filter(filterFn)
//   // .sortBy((o)=>{
//   //   return fHoldingsMap[o.id].market_value * -1
//   // })
//   // .take(10)
//   .value()
// }

@CSSModules(Styles)
export default class CompanyList extends Component {
  static propTypes = {
  }
  constructor(props){
    super(props);
  }

  renderHoldings = (currency, holdings, type) => {
    if( !holdings || holdings.length === 0 ){
      return (
        <div styleName='holdings-none'>NONE</div>
      )
    }
    const highestLowest = type === 'top' ? 'highest' : 'lowest'
    return chain(holdings)
    .take(MaxPerPage)
    .map((holding, idx) =>{
      return (
        <li key={idx} styleName='holding'>
          {
            idx===0 ?
              (
                <div
                  styleName={'holding-name-'+highestLowest}
                  data-multiline
                  data-effect='solid'
                  data-place='top'
                  data-for={type+'-tip'}
                  data-html
                  // data-scroll-hide={false}
                  data-tip={
                    format.tooltipHtml(
                      `
                        ${holding.security_name} is
                        the ${highestLowest} scored holding in this fund
                      `
                    )
                  }
                >
                  {idx+1}. {holding.security_name}
                  <ReactTooltip id={type+'-tip'}/>
                </div>
              ) :
              (
                <div styleName='holding-name'>
                  {idx+1}. {holding.security_name}
                </div>
              )
          }
          <div styleName='holding-asset'>
            {format.perc(holding.long_weight)} of assets
          </div>
          <div styleName='holding-invested'>
            {
              format.money(holding.market_value, true, currency, true)
            } invested
          </div>
        </li>
      )
    })
    .value()
  }

  renderCompanies = (currency, type, label, description=null, count, holdings) => {
    count = convert.int(count)
    if( count === 0 ){
      return (
        <Col xs={12} styleName='detail-holdings-wrapper'>
          <div styleName='detail-wrapper-empty'>
            <div styleName='detail-title-empty'>{label}</div>
          </div>
        </Col>
      )
    }
    return (
      <Col xs={12} styleName='detail-holdings-wrapper'>
        <div styleName={'detail-'+type}>
          <div styleName='detail-title-holdings'>
            <div styleName='detail-title-base'>{label}</div>
          </div>
          <div styleName='detail-description-holdings'>
            {description}
          </div>
          <ul styleName='detail-holdings'>
            { this.renderHoldings(currency, holdings, type) }
          </ul>
        </div>
      </Col>
    )
  }

  render() {
    const currency = this.props.currency
    const holdings = this.props.holdings
    const fholdings = this.props.fholdings
    const fHoldingsMap = mapFundHoldings(fholdings)
    const eqHoldings = holdings.reduce((filtered, h) => {
      h.market_value = convert.int(fHoldingsMap[h.id].market_value)
      h.long_weight = fHoldingsMap[h.id].long_weight
      h.gef_score = h.gef_score === null ? null : convert.float(h.gef_score)
      if (!(h.gef_score === undefined || h.gef_score === null)) {
        filtered.push(h)
      }
      return filtered
    }, [])

    const topHoldings = orderBy(eqHoldings, ['gef_score', 'market_value'], ['desc', 'desc'])
    const bottomHoldings = orderBy(eqHoldings, ['gef_score', 'market_value'], ['asc', 'desc'])
    const top = topHoldings.slice(0, 10)
    const bottom = bottomHoldings.slice(0, 10)
    const count = top.length

    const topDescription = `The top ${count} holdings in this portfolio with the best scores on the Equileap Gender Scorecard. In the case of ties, the holding with more assets invested is listed higher.`
    const bottomDescription = `The bottom ${count} holdings in this portfolio with the worst scores on the Equileap Gender Scorecard. In the case of ties, the holding with more assets invested is listed higher.`

    const upArrow = require( '../../../static/images/holdings-up-arrow.svg' )
    const downArrow = require( '../../../static/images/holdings-down-arrow.svg' )

    return (
      <div>
        <Row styleName='details'>
            <img
              src={upArrow}
              alt='Top scoring holdings'
              styleName='arrow'
            />
          { this.renderCompanies(currency, 'top', 'Top scoring holdings', topDescription, count, top) }
        </Row>
        <Row styleName='details'>
            <img
              src={downArrow}
              alt='Bottom scoring holdings'
              styleName='arrow'
            />
          { this.renderCompanies(currency, 'bottom', 'Bottom scoring holdings', bottomDescription, count, bottom) }
        </Row>
      </div>
    )
  }
}

